// extracted by mini-css-extract-plugin
export default {"button":"iedO66gGun0mBEFK20r_","plus":"j9Djb9T9jbsOeUy0ojYC"};